import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'

import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('listIntegrations')

  return (
    <>
      <Grid justify="flex-start" align="center" gutter={0.3}>
        <Col flex={1}>
          <Title size="h4" color="dark1" noMargin>
            {t('modalTitle')}
          </Title>
          <SmallText color="dark3"></SmallText>
        </Col>
        <Col flex={1}></Col>
      </Grid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
